// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__XcJxG","sidebar__wrapper":"Sidebar_sidebar__wrapper__dtrwz","sidebar__support":"Sidebar_sidebar__support__DvRPa"};